import { render, staticRenderFns } from "./asset_config.vue?vue&type=template&id=21671e37&scoped=true&"
import script from "./asset_config.vue?vue&type=script&lang=js&"
export * from "./asset_config.vue?vue&type=script&lang=js&"
import style0 from "./asset_config.vue?vue&type=style&index=0&id=21671e37&scoped=true&lang=less&"
import style1 from "./asset_config.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21671e37",
  null
  
)

export default component.exports